'use strict';

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var imageLayout = require('./bgImageLayout');

function wixBgImageWrapper(WixElement, services, environmentConsts) {
  var WixBgImage =
  /*#__PURE__*/
  function (_WixElement) {
    _inheritsLoose(WixBgImage, _WixElement);

    function WixBgImage() {
      // eslint-disable-line no-useless-constructor
      return _WixElement.call(this) || this;
    }

    var _proto = WixBgImage.prototype;

    _proto.reLayout = function reLayout() {
      var domNodes = {};
      var measures = {};
      var imageId = this.getAttribute('id');
      var imageInfo = JSON.parse(this.dataset.tiledImageInfo);
      domNodes[imageId] = this;
      domNodes[imageInfo.containerId] = document.getElementById("" + imageInfo.containerId);
      imageInfo.displayMode = imageInfo.imageData.displayMode;
      services.mutationService.measure(function () {
        imageLayout.measure(imageId, measures, domNodes, imageInfo.containerId);
      });
      services.mutationService.mutate(function () {
        imageLayout.patch(imageId, measures, domNodes, imageInfo, environmentConsts);
      });
    };

    _proto.attributeChangedCallback = function attributeChangedCallback(name, oldValue) {
      if (oldValue) {
        this.reLayout();
      }
    };

    _proto.disconnectedCallback = function disconnectedCallback() {
      _WixElement.prototype.disconnectedCallback.call(this);
    };

    _createClass(WixBgImage, null, [{
      key: "observedAttributes",
      get: function get() {
        return ['data-tiled-image-info'];
      }
    }]);

    return WixBgImage;
  }(WixElement);

  return WixBgImage;
}

module.exports = wixBgImageWrapper;
//# sourceMappingURL=wixBgImage.js.map